interface Principle {
  num: string;
  title: string;
  body: string;
}

const PRINCIPLES: Principle[] = [
  {
    num: "01",
    title: "Embedded, not adjacent.",
    body: "I work inside your repo, your Slack, your standups. The fastest way to ship the right thing is to be near the people who know what it is.",
  },
  {
    num: "02",
    title: "Evidence over adjectives.",
    body: "Decisions are tied to what's actually happening in the system — traces, logs, evals, the thing in front of a user. Less arguing about whether it's good. More showing.",
  },
  {
    num: "03",
    title: "Boring infrastructure, sharp surface.",
    body: "Postgres, Docker, Terraform, off-the-shelf cloud — the unsexy substrate. The AI sits on top. Reliable beats clever, every quarter.",
  },
  {
    num: "04",
    title: "Leave it better than you found it.",
    body: "I write docs your team will actually read, runbooks they'll actually run, and code their next hire can extend. Replaceability is the point.",
  },
];

export function Approach() {
  return (
    <section id="approach" style={{ position: "relative", padding: "var(--section-y, 120px) 32px" }}>
      <div className="container">
        <div
          className="grid-2"
          style={{
            display: "grid",
            gridTemplateColumns: "minmax(0, 340px) minmax(0, 1fr)",
            gap: 64,
            alignItems: "flex-start",
          }}
        >
          <div
            className="approach-aside"
            style={{ display: "flex", flexDirection: "column", gap: 24, position: "sticky", top: 100 }}
          >
            <span className="rule-eyebrow">Approach</span>
            <h2
              style={{
                margin: 0,
                fontFamily: "var(--font-display)",
                fontWeight: 300,
                fontSize: "clamp(36px, 4.4vw, 52px)",
                lineHeight: 1.04,
                letterSpacing: "-0.02em",
                color: "var(--ink)",
              }}
            >
              How the work goes.
            </h2>
            <p style={{ margin: 0, fontFamily: "var(--font-body)", fontSize: 15, lineHeight: 1.6, color: "var(--ink-3)", maxWidth: 320 }}>
              Four principles that hold across an AI feature, a product rebuild, or a network install.
            </p>
          </div>

          <div style={{ display: "flex", flexDirection: "column" }}>
            {PRINCIPLES.map((principle, i) => (
              <div
                key={principle.num}
                className="principle-row"
                style={{
                  padding: "32px 0",
                  borderTop: i === 0 ? "1px solid var(--hairline)" : "none",
                  borderBottom: "1px solid var(--hairline)",
                  display: "grid",
                  gridTemplateColumns: "60px 1fr",
                  gap: 24,
                }}
              >
                <span style={{ fontFamily: "var(--font-mono)", fontSize: 13, color: "var(--ink-4)", letterSpacing: "0.04em", paddingTop: 6 }}>
                  {principle.num}
                </span>
                <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                  <h3
                    style={{
                      margin: 0,
                      fontFamily: "var(--font-display)",
                      fontWeight: 500,
                      fontSize: 26,
                      lineHeight: 1.15,
                      letterSpacing: "-0.01em",
                      color: "var(--ink)",
                    }}
                  >
                    {principle.title}
                  </h3>
                  <p style={{ margin: 0, maxWidth: 580, fontFamily: "var(--font-body)", fontSize: 15, lineHeight: 1.6, color: "var(--ink-2)" }}>
                    {principle.body}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
